import { registerLocale } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import type { Plugin } from 'vue';

let installed = false;

export const isoCountryPlugin: Plugin = {
  install() {
    if (installed) {
      return;
    }

    registerLocale(en);

    installed = true;
  },
};
